import axios from '@/utils/api'

export async function buscarProcesso (numProcesso) {
  try {
    const response = await axios({
      method: 'GET',
      url: `processo/findByNumero?numeroProcesso=${numProcesso.trim()}`
    })
    return response
  } catch (e) {
    return false
  }
}

export async function erro404 (idProcesso) {
  try {
    await axios({
      method: 'POST',
      url: 'manutencao/regerarPlantaMemorial/erro404',
      data: [idProcesso]
    })
    return 'ok'
  } catch (e) {
    return false
  }
}

export async function getXmlFluxo (numeroProcesso, tipo) {
  try {
    const dados = await axios({
      method: 'GET',
      url: `fluxoXml/xml?numeroProcesso=${numeroProcesso}&tipoProcesso=${tipo}`
    })
    return dados
  } catch (e) {
    return false
  }
}

export async function moverProcesso (idProcesso, acao, mensagem) {
  const body = {
    idProcesso: idProcesso,
    acao: acao,
    mensagem: mensagem
  }
  try {
    await axios({
      method: 'POST',
      url: 'manutencao/move/processo/acao',
      data: body
    })
    return 'ok'
  } catch (e) {
    return false
  }
}

export async function moverProcessoMa (idProcesso, acao, mensagem, deletaAssinatura, documentos) {
  const body = {
    idProcesso: idProcesso,
    acao: acao,
    mensagem: mensagem,
    deletaAssinatura: deletaAssinatura,
    documentos
  }
  try {
    await axios({
      method: 'POST',
      url: 'manutencao/move/processo/acao/ma',
      data: body
    })
    return 'ok'
  } catch (e) {
    return false
  }
}

export async function distribuirProcesso (acao, acaoAtual, saidasEsperadas, numeroProcesso, idProcesso, mensagem, documentos) {
  const body = {
    acao: acao,
    acaoAtual: acaoAtual,
    saidasEsperadas: saidasEsperadas,
    numeroProcesso: numeroProcesso,
    setor: 'SISTEMA',
    perfil: 'SISTEMA',
    setRevisionOrigensNull: false,
    idProcesso: idProcesso,
    mensagem: mensagem,
    documentos: documentos
  }
  try {
    await axios({
      method: 'POST',
      url: 'manutencao/tramitar/processo/acao',
      data: body
    })
    return 'ok'
  } catch (e) {
    return false
  }
}

export async function buscarTarefa (idProcesso) {
  try {
    const response = await axios({
      method: 'GET',
      url: `manutencao/decisoes/processo/${idProcesso}`
    })
    return response
  } catch (e) {
    return false
  }
}

export async function buscarTasks (idProcesso) {
  try {
    const response = await axios({
      method: 'GET',
      url: `manutencao/tasks/processo/${idProcesso}`
    })
    return response
  } catch (e) {
    return false
  }
}

export async function voltarProcesso (idProcesso, indexListagem, mensagem) {
  const body = {
    idsProcesso: [idProcesso],
    indexListagemHistory: indexListagem,
    mensagem: mensagem
  }
  try {
    await axios({
      method: 'POST',
      url: 'manutencao/voltar/processo',
      data: body
    })
    return 'ok'
  } catch (e) {
    return false
  }
}

export async function buscarFilaAnaliseAutomatizada (pagina, numeroProcesso) {
  try {
    const response = await axios({
      method: 'GET',
      url: `manutencao/fila-analise-automatizada`,
      params: {
        pagina,
        numeroProcesso,
        itensPorPagina: 10
      }
    })
    return response
  } catch (e) {
    return false
  }
}

export async function regerarAnalise (idAnalise) {
  try {
    const response = await axios({
      method: 'PUT',
      url: `manutencao/regerar-analise/${idAnalise}`
    })
    return response
  } catch (e) {
    return false
  }
}

export async function buscarInformacoesAnalise (jobId) {
  try {
    const response = await axios({
      method: 'GET',
      url: `manutencao/informacoes-analise/${jobId}`
    })
    return response
  } catch (e) {
    return false
  }
}

export async function buscarTiposCadastros () {
  try {
    const response = await axios({
      method: 'GET',
      url: 'manutencao/informacoes-tiposCadastro'
    })
    return response
  } catch (e) {
    return false
  }
}

export async function buscarSetores () {
  try {
    const response = await axios({
      method: 'GET',
      url: 'manutencao/informacoes-setores'
    })
    return response
  } catch (e) {
    return false
  }
}

export async function buscarStatus () {
  try {
    const response = await axios({
      method: 'GET',
      url: 'manutencao/informacoes-status'
    })
    return response
  } catch (e) {
    return false
  }
}

export async function regerarCertidaoQuitacao (idProcesso) {
  try {
    const response = await axios({
      method: 'GET',
      url: `manutencao/regerarCertidaoQuitacao/${idProcesso}/REGERAR_CERTIDAO`
    })
    return response
  } catch (e) {
    return false
  }
}

export async function gerarNovoDaeAutomaticoGacVencido (idProcesso) {
  try {
    const response = await axios({
      method: 'GET',
      url: `manutencao/gerarNovoDaeAutomaticoGacVencido/${idProcesso}/GERAR_NOVO_DAE`
    })
    return response
  } catch (e) {
    return false
  }
}

export async function retornaProcessoFluxoForaMonitoramento (id) {
  try {
    const response = await axios({
      method: 'GET',
      url: `manutencao/retornaProcessoFluxoForaMonitoramento/${id}/RETORNAR_PROCESSO`
    })
    return response
  } catch (e) {
    return false
  }
}

export async function buscarUsuarios (setor) {
  try {
    const response = await axios({
      method: 'GET',
      url: `manutencao/buscarUsuarios/${setor}`
    })
    return response
  } catch (e) {
    return false
  }
}

export async function startProcessoFluxoMonitoramento (id) {
  try {
    const response = await axios({
      method: 'GET',
      url: `manutencao/startProcessoFluxoMonitoramento/${id}/STARTAR_PROCESSO`
    })
    return response
  } catch (e) {
    return false
  }
}

export async function trocarUsuario (idUsuario, idProcesso, mensagem) {
  const body = {
    idUsuario: idUsuario,
    idProcesso: idProcesso,
    mensagem: mensagem
  }
  try {
    const response = await axios({
      method: 'POST',
      url: `manutencao/trocarUsuario`,
      data: body
    })
    return response
  } catch (e) {
    return false
  }
}

export async function enviarDadosVerificaAtualizaFluxo (status, setores, tiposCadastros, atualizaSubProcesso) {
  const body = {
    status: status,
    setores: setores,
    tipoCadastros: tiposCadastros,
    atualizaSubProcesso: atualizaSubProcesso
  }
  try {
    const response = await axios({
      method: 'POST',
      url: 'manutencao/verifica/atualizaFluxo',
      data: body
    })
    return response
  } catch (e) {
    return false
  }
}

export async function moverRemessa (caixaAtual, statusAtuais, caixaDestino, acaoInicialCaixaDestino, acaoDestino, perfil, setor, saidasEsperadasCaixaDestino) {
  const body = {
    caixaAtual: caixaAtual,
    statusAtuais: statusAtuais,
    caixaDestino: caixaDestino,
    acaoInicialCaixaDestino: acaoInicialCaixaDestino,
    acaoDestino: acaoDestino,
    perfil: perfil,
    setor: setor,
    saidasEsperadasCaixaDestino: saidasEsperadasCaixaDestino
  }
  try {
    const response = await axios({
      method: 'POST',
      url: 'manutencao/move/varios',
      data: body
    })
    return response
  } catch (e) {
    return false
  }
}

export async function retificarMassa (mensagem, titulo, ids) {
  const body = {
    ids: ids,
    titulo: titulo,
    mensagem: mensagem
  }
  try {
    const response = await axios({
      method: 'POST',
      url: 'manutencao/retificarEmMassa',
      data: body
    })
    return response
  } catch (e) {
    return false
  }
}

export async function salvarModulo (body) {
  try {
    const response = await axios({
      method: 'POST',
      url: '/gerenciarModulos/salvarModulos',
      data: body
    })
    return response
  } catch (e) {
    return false
  }
}

export async function buscarModulos () {
  try {
    const response = await axios({
      method: 'GET',
      url: 'gerenciarModulos/retornarModulos'
    })
    return response
  } catch (e) {
    return false
  }
}

export async function deletarModulosPorId (id) {
  try {
    const response = await axios({
      method: 'DELETE',
      url: `gerenciarModulos/deletarModulos/${id}`
    })
    return response
  } catch (e) {
    return false
  }
}

export async function editaModulo (id, body) {
  try {
    const response = await axios({
      method: 'PUT',
      url: `gerenciarModulos/editarModulo/${id}`,
      data: body
    })
    return response
  } catch (e) {
    return false
  }
}

export async function executarComando (id, acao) {
  try {
    const response = await axios({
      method: 'PUT',
      url: `gerenciarModulos/executarComando/${id}/${acao}`
    })
    return response
  } catch (e) {
    return false
  }
}

export async function buscarProcessoFlowable (numeroProcesso) {
  try {
    const response = await axios({
      method: 'GET',
      url: `manutencao/buscarProcessoFlowable?numeroProcesso=${numeroProcesso.trim()}`
    })
    return response
  } catch (e) {
    return false
  }
}

export async function sincronizarDadosProcesso (idProcesso) {
  try {
    const response = await axios({
      method: 'GET',
      url: `manutencao/sincronizaStatus/${idProcesso}`
    })
    return response
  } catch (e) {
    return false
  }
}

export async function registerClient (titulo) {
  try {
    const response = await axios({
      method: 'GET',
      url: `wap/api/register?name=${titulo}`
    })
    return response
  } catch (e) {
    console.error('Erro ao registrar o cliente:', e)
    return false
  }
}

export async function getProcessos (pagina, filtro, filter) {
  try {
    let dataInicio = null
    let dataFim = null
    if (filter.periodoCadastro) {
      dataInicio = filter.periodoCadastro[0].getFullYear() + '-' + ('0' + (Number(filter.periodoCadastro[0].getMonth()) + 1)).slice(-2) + '-' + ('0' + Number(filter.periodoCadastro[0].getDate())).slice(-2)
      dataFim = filter.periodoCadastro[1].getFullYear() + '-' + ('0' + (Number(filter.periodoCadastro[0].getMonth()) + 1)).slice(-2) + '-' + ('0' + Number(filter.periodoCadastro[1].getDate())).slice(-2)
    }
    const response = await axios({
      method: 'GET',
      url: 'manutencao/wap/processos',
      params: {
        ...filter,
        dataInicio,
        dataFim,
        periodoCadastro: null,
        ordem: filtro.ordem || 'id',
        ordemDirecao: filtro.ordemDirecao || 'ASC',
        pagina,
        itensPorPagina: 15
      }
    })
    return response
  } catch (e) {
    console.error('Erro ao registrar o cliente:', e)
    return false
  }
}

export async function getClients () {
  try {
    const response = await axios({
      method: 'GET',
      url: 'wap/api/clients'
    })
    return response
  } catch (e) {
    console.error('Erro ao registrar o cliente:', e)
    return false
  }
}

export async function getQRCode (uuid) {
  try {
    const response = await axios({
      method: 'GET',
      url: `wap/api/getQRCode/${uuid}`
    })
    return response
  } catch (e) {
    console.error(`Erro ao obter o QR Code do cliente ${uuid}:`, e)
    return false
  }
}

export async function sendMessage (numero, mensagem, clientId) {
  try {
    const response = await axios({
      method: 'POST',
      url: 'wap/api/sendMessage',
      data: {
        numero: numero.trim(),
        mensagem: mensagem.trim(),
        clientId: clientId.trim()
      }
    })
    return response
  } catch (e) {
    console.error('Erro ao enviar a mensagem:', e)
    return false
  }
}

export async function disconnectClient (uuid) {
  try {
    const response = await axios({
      method: 'DELETE',
      url: `wap/api/disconnect/${uuid}`
    })
    return response
  } catch (e) {
    console.error(`Erro ao desconectar o cliente ${uuid}:`, e)
    return false
  }
}

export async function programarMensagens (mensagens, filter) {
  try {
    let dataInicio = null
    let dataFim = null
    if (filter?.periodoCadastro) {
      dataInicio = filter.periodoCadastro[0].getFullYear() + '-' + ('0' + (Number(filter.periodoCadastro[0].getMonth()) + 1)).slice(-2) + '-' + ('0' + Number(filter.periodoCadastro[0].getDate())).slice(-2)
      dataFim = filter.periodoCadastro[1].getFullYear() + '-' + ('0' + (Number(filter.periodoCadastro[0].getMonth()) + 1)).slice(-2) + '-' + ('0' + Number(filter.periodoCadastro[1].getDate())).slice(-2)
    }
    const response = await axios({
      method: 'POST',
      url: 'wap/api/programarMensagens',
      data: {
        ...filter,
        ...mensagens,
        dataInicio,
        dataFim
      }
    })
    return response
  } catch (e) {
    console.error('Erro ao programar as mensagens:', e)
    return false
  }
}

export async function getStatusDisparo () {
  try {
    const response = await axios({
      method: 'GET',
      url: 'wap/api/statusMenssagensProgramadas'
    })
    return response
  } catch (e) {
    console.error('Erro ao programar as mensagens:', e)
    return false
  }
}

export async function getChavesSeguranca () {
  try {
    const response = await axios({
      method: 'GET',
      url: 'v1/chave-seguranca'
    })
    return response
  } catch (e) {
    console.error('Erro ao programar as mensagens:', e)
    return false
  }
}
export async function salvarChave (chave) {
  try {
    const response = await axios({
      method: 'POST',
      url: 'v1/chave-seguranca',
      data: chave
    })
    return response
  } catch (e) {
    console.error('Erro ao programar as mensagens:', e)
    return false
  }
}
export async function alterarStatusChave (id, ativa) {
  try {
    const response = await axios({
      method: 'PUT',
      url: `/v1/chave-seguranca/${id}/status`,
      params: { ativa }
    })
    return response
  } catch (e) {
    console.error('Erro ao alterar o status da chave de segurança:', e)
    return false
  }
}

export async function getLogsPorChave (id, pageable = {}) {
  try {
    const response = await axios({
      method: 'GET',
      url: `/v1/chave-seguranca/${id}/logs`,
      params: pageable
    })
    return response
  } catch (e) {
    console.error('Erro ao listar os logs da chave de segurança:', e)
    return false
  }
}

export async function buscarUsuariosPerfil (perfil) {
  try {
    const response = await axios({
      method: 'GET',
      url: `/manutencao/buscarUsuariosPerfil/${perfil}`
    })
    return response
  } catch (e) {
    console.error('Erro ao listar os logs da chave de segurança:', e)
  }
}

export async function trataAcoesDistribuirProcessos (idProcesso, tasks) {
  try {
    const response = await axios({
      method: 'POST',
      url: `manutencao/trataAcoesDistribuirProcessos/${idProcesso}`,
      data: tasks
    })
    return response
  } catch (e) {
    console.error('Erro ao buscar acoes', e)
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/manutencao.js